export default __webpack_public_path__ + "static/media/open-box.1ad99811.svg";